import { groupsQueryOptions } from '@/hooks/contacts/use-groups';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function contactGroupsIndexLoader() {
  return {
    promises: queryClient.ensureQueryData(groupsQueryOptions).catch(catchFetcherError),
  };
}
